import React from 'react';
/**
 * @deprecated utiliser `ModalV2Footer`. Sera supprimé dans une futur Release d'ici fin 2025.
 */
var ModaleFooter = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "fr-modal__footer" }, children));
};
export default ModaleFooter;
